import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { BlockUIModule } from "primeng/blockui";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { AuthService } from "../../../services/auth/auth.service";
import { PathService } from "../../../services/auth/path.service";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    CardModule,
    RouterLink,
    BlockUIModule,
  ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent {
  email = "";
  password = "";
  loginFailed = false;
  blockedPanel = false;

  constructor(private authService: AuthService, private pathService: PathService, private router: Router) {
  }

  blurred() {
    this.loginFailed = false;
  }

  async login() {
    this.blockedPanel = true;
    try {
      await this.authService.login(this.email, this.password)
      .catch((error) => {
        this.blockedPanel = false;
        this.loginFailed = true;
        console.error("Login failed:", error);
      });
      console.log("Navigate", this.pathService.getPath());
      this.router.navigate([this.pathService.getPath()]);
    } catch (error) {
      this.blockedPanel = false;
      console.error("Google Login Error:", error);
    }
  }

  async loginWithGoogle() {
    this.blockedPanel = true;
    try {
      const user = await this.authService.loginWithGoogle();
      if (user)
      {
        console.log("Navigate", this.pathService.getPath());
        this.router.navigate([this.pathService.getPath()]);
      }
      else
      {
        return Promise.reject("Auth failed");
      }
    } catch (error) {
      this.blockedPanel = false;
      console.error("Google Login Error:", error);
    }
  }
}
